<template>
  <resource-layout>
    <template v-slot:header>
      <resource-list-page-header :resourceTitle="resourceTitle">
        <template v-slot:desc>
          <slot name="desc" v-slot:desc></slot>
        </template>
        <template v-slot:filter>
          <slot name="filter" v-slot:filter></slot>
        </template>
        <template v-slot:operation>
          <slot name="operation" v-slot:operation></slot>
        </template>
      </resource-list-page-header>
    </template>
    <slot></slot>
    <template v-slot:footer>
      <resource-list-page-footer v-show="showFooter"></resource-list-page-footer>
    </template>
    <template v-slot:drawer>
      <slot name="drawer"></slot>
    </template>
  </resource-layout>
</template>

<script>
import ResourceLayout from './ResourceLayout'
import ResourceListPageHeader from './ResourceListPageHeader'
import ResourceListPageFooter from './ResourceListPageFooter'
export default {
  name: 'ResourceListLayout',
  props: {
    resourceTitle: {
      type: String,
      default: '无标题'
    },
    showFooter: {
      type: Boolean,
      default: true
    }
  },
  components: {
    ResourceLayout,
    ResourceListPageHeader,
    ResourceListPageFooter
  }
}
</script>

<style lang="stylus" scoped>
</style>



// WEBPACK FOOTER //
// src/common/ResourceListLayout.vue